import React, { useState, useEffect } from "react";
import "./Transactions.scss";
import { Form, Select, DatePicker, Input } from "antd";
import columns from "../../../columns/transactions.jsx";
import ModalComponent from "../../../components/modals/ModalComponent.jsx";
import ConfirmationModal from "../../../components/modals/ConfirmationModal.jsx";
import TableWithSkeleton from "../../../components/table/TableWithSkeleton.jsx";
import Pagination from "../../../components/pagination/Pagination.jsx";
import { useSelector } from "react-redux";
import { GetTransactionsApi } from "../../../api/request/transactions.js";
import Eye from "../../../assets/Eye.jsx";
import moment from "moment/moment.js";
import ReactPlayer from "react-player";
import { GetAllTutorialsApi } from "../../../api/request/tutorials.js";
import Segmented from "../../../components/segmented/Segmented.jsx";
import { useSearchParams, useNavigate } from "react-router-dom";
import ExportHandler from "../../../components/global/export/ExportHandler.jsx";
import { useLocation } from "react-router-dom";
import { useResponsive } from "../../../hooks/useResponsive.js";
import { DownOutlined } from "@ant-design/icons";
import { AddWithdrawRequestApi } from "../../../api/request/wallet/withdraw.js";
import toast from "react-hot-toast";
import { handleApiError } from "../../../utils/handleApiError.js";
import Refund from "../../../assets/Refund.jsx";

const { RangePicker } = DatePicker;

export default function Transactions() {
  const { isMobile } = useResponsive();
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user);
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTransaction, setSelectedTransaction] = useState({});
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalvideo, setIsOpenModalvideo] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [data, setData] = useState([]);
  const [tutorials, setTutorials] = useState();
  const [tutorialsdetails, setTutorialsdetails] = useState({});
  const [isOpenModaldetails, setIsOpenModaldetails] = useState(false);
  const [filter, setFilter] = useState("All");
  const location = useLocation();
  const [filterValue, setFilterValue] = useState("");
  const [dates, setDates] = useState([]);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [refundTransaction, setRefundTransaction] = useState(null);
  const [refundAmount, setRefundAmount] = useState("");
  const [isRefundConfirmOpen, setIsRefundConfirmOpen] = useState(false);
  const [isRefundLoading, setIsRefundLoading] = useState(false);

  const options = [
    "All",
    "Deposit",
    "Withdrawal",
    "Wallet To Account",
    "Account To Wallet",
    "IBWallet To Wallet",
  ];

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const filter = searchParams.get("filter");
    if (filter) {
      setFilterValue(decodeURIComponent(filter));
    }
  }, [location.search]);

  const paymentTypeFromUrl = new URLSearchParams(location.search).get("paymentType") || "";
  const [preservePaymentTypeOnFilterChange, setPreservePaymentTypeOnFilterChange] = useState(
    () => !!new URLSearchParams(location.search).get("paymentType")
  );

  const getTransactions = async () => {
    try {
      setIsLoading(true);
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        FromDate: dates.length === 2 ? dates[0].format("MM-DD-YYYY") : "",
        ToDate: dates.length === 2 ? dates[1].format("MM-DD-YYYY") : "",
        FilterText:
          filterValue === "All"
            ? " "
            : filterValue === "Deposit"
              ? "Deposit"
              : filterValue === "Withdrawal"
                ? "Withdrawal"
                : filterValue === "Wallet To Account"
                  ? "WalletToAccount"
                  : filterValue === "Account To Wallet"
                    ? "AccountToWallet"
                    : filterValue === "IBWallet To Wallet"
                      ? "IBWalletToWallet"
                      : filterValue,
        paymentType: paymentTypeFromUrl,
      };
      const { data } = await GetTransactionsApi(
        userDetails?._id,
        new URLSearchParams(params).toString()
      );
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              status:
                item?.status === "Success" ? (
                  <span className="px-3 py-1 rounded-full uppercase text-xs text-center success_tag">
                    Success
                  </span>
                ) : (
                  <span className="uppercase px-3 py-1 rounded-full text-xs text-center fail_tag">
                    Fail
                  </span>
                ),
              actions: (
                <div className="flex items-center gap-2">
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      setSelectedTransaction(item);
                      setIsOpenModal(true);
                    }}
                  >
                    <Eye />
                  </div>
                  {item?.status === "Success" &&
                    Number(item?.refundableAmount ?? 0) > 0 && (
                      <div
                        className="cursor-pointer text-primary hover:opacity-80"
                        onClick={(e) => {
                          e.stopPropagation();
                          setRefundTransaction(item);
                          setRefundAmount("");
                          setIsRefundModalOpen(true);
                        }}
                        title="Refund"
                      >
                        <Refund />
                      </div>
                    )}
                </div>
              ),
              transactionDate: item?.transactionDate
                ? moment(item?.transactionDate).format("DD-MM-YYYY LT")
                : null,
              amount: `$ ${item?.amount}`,
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setData([]);
      setIsLoading(false);
    }
  };

  const getAllTutorials = async () => {
    try {
      setIsLoading(true);
      let params = {
        tutorialType: "Transactions",
      };
      const { data } = await GetAllTutorialsApi(
        new URLSearchParams(params).toString()
      );
      if (data?.success) {
        setTutorials(data?.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTransactions();
  }, [page, pageSize, dates, filterValue, paymentTypeFromUrl]);

  useEffect(() => {
    if (searchParams?.get("filter")) {
      setFilter(searchParams?.get("filter"));
    }
    getAllTutorials();
  }, []);

  useEffect(() => {
    const existingPaymentType = new URLSearchParams(location.search).get("paymentType");
    const next = new URLSearchParams({ filter });
    if (preservePaymentTypeOnFilterChange && existingPaymentType) next.set("paymentType", existingPaymentType);
    setSearchParams(next);
    form?.resetFields();
  }, [filter]);

  useEffect(() => {
    setPage(1);
  }, [dates]);
  const exportHandler = async () => {
    try {
      let params = {
        ApplyPagination: false,
        FromDate:
          dates && dates.length === 2 ? dates[0].format("MM-DD-YYYY") : "",
        ToDate:
          dates && dates.length === 2 ? dates[1].format("MM-DD-YYYY") : "",
        FilterText:
          filterValue === "All"
            ? " "
            : filterValue === "Deposit"
              ? "Deposit"
              : filterValue === "Withdrawal"
                ? "Withdrawal"
                : filterValue === "Wallet To Account"
                  ? "WalletToAccount"
                  : filterValue === "Account To Wallet"
                    ? "AccountToWallet"
                    : filterValue === "IBWallet To Wallet"
                      ? "IBWalletToWallet"
                      : filterValue,
        paymentType: paymentTypeFromUrl,
      };
      const { data } = await GetTransactionsApi(
        userDetails?._id,
        new URLSearchParams(params).toString()
      );
      if (data?.success) {
        return {
          data: data?.data,
          removableColumns: ["userId", "transactionId"],
          fileName: "Transactions",
        };
      } else {
        return { data: [], removableColumns: [] };
      }
    } catch (error) {
      return { data: [], removableColumns: [] };
    }
  };

  const addTutorialsModalHandler = (Item) => {
    setIsOpenModaldetails(true);
    setTutorialsdetails(Item);
  };

  const handleRefundSubmit = () => {
    const amount = Number(refundAmount);
    const maxRefund = Number(refundTransaction?.refundableAmount ?? 0);
    if (!refundAmount || isNaN(amount) || amount <= 0 || amount > maxRefund) {
      toast.error(
        `Please enter a valid amount between 1 and ${maxRefund}`
      );
      return;
    }
    setIsRefundConfirmOpen(true);
  };

  const handleRefundConfirm = async () => {
    try {
      setIsRefundLoading(true);
      const payload = {
        userId: userDetails?._id,
        amount: Number(refundAmount),
        withdrawalMethod: paymentTypeFromUrl === "MyFatoorah" ? 11 : 10,
        transactionCode: refundTransaction?.transactionCode,
      };
      const { data } = await AddWithdrawRequestApi(payload);
      if (data?.success) {
        toast.success(data?.message || "Refund request submitted successfully.");
        navigate("/withdraw");
        setIsRefundModalOpen(false);
        setIsRefundConfirmOpen(false);
        setRefundTransaction(null);
        setRefundAmount("");
        getTransactions();
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsRefundLoading(false);
    }
  };

  const closeRefundModal = () => {
    setIsRefundModalOpen(false);
    setRefundTransaction(null);
    setRefundAmount("");
    setIsRefundConfirmOpen(false);
  };

  return (
    <div
      className={`transaction-container ${isMobile ? "mobile-dashboard" : ""}`}
    >
      <div className="flex flex-wrap justify-between items-center sm:gap-5 gap-4">
        <Select
          className="w-full md:w-auto md:min-w-44  ant-select-selector-white"
          value={filter}
          onChange={(value) => {
            setPreservePaymentTypeOnFilterChange(false);
            setFilter(value);
            setPage(1);
          }}
          options={options.map((option) => ({ label: option, value: option }))}
          size="large"
          {...(isMobile && {
            suffixIcon: (
              <div className="flex items-center justify-center h-full w-full">
                <DownOutlined className="text-gray-400 bg-[#F5F9FD] p-2.5 rounded-lg" />
              </div>
            ),
          })}
          popupClassName="custom-select-dropdown"
          dropdownAlign={{ offset: [0, 0] }}
        />
        {/* <Segmented options={['All', 'Deposit', 'Withdrawal', 'Wallet To Account', 'Account To Wallet', 'IBWallet To Wallet']} value={filter}
                    // setValue={setFilter}
                    setValue={(value) => {
                        setFilter(value);
                        setPage(1);
                    }}
                /> */}
        <div className="flex flex-wrap w-full md:w-auto">
          <div className="md:mr-4 w-full md:w-auto">
            {!isMobile ? (
              <div>
                <RangePicker
                  className="border-light border-2 w-full"
                  format="DD-MM-YYYY"
                  onChange={(selectedDates) => {
                    setDates(selectedDates ? selectedDates : []);
                  }}
                />
              </div>
            ) : (
              <div className="flex justify-between gap-4 w-full">
                <DatePicker
                  onChange={(date) => {
                    setDates([date, dates[1]]);
                  }}
                  placeholder="From Date"
                  className="w-full rounded-xl py-3"
                />
                <DatePicker
                  onChange={(date) => {
                    setDates([dates[0], date]);
                  }}
                  placeholder="To Date"
                  className="w-full rounded-xl py-3"
                />
              </div>
            )}
          </div>
          <div className="md:mt-0 mt-4 w-full md:w-auto">
            <ExportHandler exportHandler={exportHandler} />
          </div>
        </div>
      </div>

      <div className="w-full mt-8">
        <div className="my-6">
          <div className="border border-gray-200 rounded-xl">
            <TableWithSkeleton
              columns={columns}
              data={data}
              loading={isLoading}
            />
          </div>
          <Pagination
            total={totalRecord}
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
          />
        </div>
      </div>

      <ModalComponent
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        title="Transaction Details"
        width={1000}
      >
        <div className="md:p-5">
          <div className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-3 md:gap-10 ">
            <div>
              <p className="text-base font-normal ">Operation</p>
              <p className="text-base md:text-xl primary font-semibold mt-1 md:mt-2">
                {selectedTransaction?.operation}
              </p>
            </div>
            <div>
              <p className="text-base font-normal">Payment From</p>
              <p className="text-base md:text-xl primary font-semibold mt-1 md:mt-2">
                {selectedTransaction?.paymentFrom}
              </p>
            </div>
            <div>
              <p className="text-base font-normal">Payment To</p>
              <p className="text-base md:text-xl primary font-semibold mt-1 md:mt-2">
                {selectedTransaction?.paymentTo}
              </p>
            </div>
            <div>
              <p className="text-base font-normal">Amount</p>
              <p className="text-base md:text-xl primary font-semibold mt-1 md:mt-2">
                $ {selectedTransaction?.amount?.toFixed(2)}
              </p>
            </div>
            <div>
              <p className="text-base font-normal pb-2">Currency</p>
              <p className="text-base md:text-xl primary font-semibold mt-1 md:mt-2">
                {selectedTransaction?.currency}
              </p>
            </div>
            <div>
              <p className="text-base font-normal">Status</p>
              <p className="text-base md:text-xl primary font-semibold mt-1 md:mt-2">
                {selectedTransaction?.status}
              </p>
            </div>
            <div>
              <p className="text-base font-normal">Transaction Date</p>
              <p className="text-base md:text-xl primary font-semibold mt-1 md:mt-2">
                {moment(selectedTransaction?.transactionDate).format(
                  "DD-MM-YYYY"
                )}
              </p>
            </div>
            <div>
              <p className="text-base font-normal">Transaction Code</p>
              <p className="text-base md:text-xl primary font-semibold mt-1 md:mt-2">
                {selectedTransaction?.transactionCode}
              </p>
            </div>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent
        isOpen={isOpenModalvideo}
        setIsOpen={setIsOpenModalvideo}
        title="Tutorial"
        width={1000}
      >
        {tutorials && tutorials.length > 0 ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-5 mt-6">
            {tutorials.map((item, index) => (
              <div
                key={index}
                className="shadow-lg cursor-pointer rounded-t-2xl overflow-hidden"
                onClick={() => addTutorialsModalHandler(item)}
              >
                <div className="relative pb-[56.25%] h-0">
                  {item.youtubeUrl ? (
                    <ReactPlayer
                      url={item.youtubeUrl}
                      className="absolute top-0 left-0 w-full h-full"
                      width="100%"
                      height="100%"
                      controls
                    />
                  ) : item.videoUrl ? (
                    <ReactPlayer
                      url={item.videoUrl}
                      className="absolute top-0 left-0 w-full h-full"
                      width="100%"
                      height="100%"
                      controls
                    />
                  ) : (
                    <p>Video not available</p>
                  )}
                </div>
                <div className="text-center p-4">
                  <p className="text-lg font-semibold line-limit-1">
                    {item.title}
                  </p>
                  <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center">
            <p className="text-lg font-semibold">Video not available</p>
          </div>
        )}
      </ModalComponent>

      <ModalComponent
        isOpen={isOpenModaldetails}
        setIsOpen={setIsOpenModaldetails}
        title="Tutorial"
        width={800}
      >
        <div className="relative pb-[56.25%] h-0">
          {tutorialsdetails.youtubeUrl ? (
            <ReactPlayer
              url={tutorialsdetails.youtubeUrl}
              className="absolute top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              controls
            />
          ) : tutorialsdetails.videoUrl ? (
            <ReactPlayer
              url={tutorialsdetails.videoUrl}
              className="absolute top-0 left-0 w-full h-full"
              width="100%"
              height="100%"
              controls
            />
          ) : (
            <p>Video not available</p>
          )}
        </div>
        <div className="text-center p-4">
          <p className="text-lg font-semibold line-limit-1">
            {tutorialsdetails?.title}
          </p>
          <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">
            {tutorialsdetails?.description}
          </p>
        </div>
      </ModalComponent>

      <ModalComponent
        isOpen={isRefundModalOpen}
        setIsOpen={closeRefundModal}
        title="Refund"
        width={480}
      >
        <div className="p-4">
          <div className="mb-4">
            <p className="text-base font-normal text-gray-600">
              Refundable Amount
            </p>
            <p className="text-xl font-semibold text-[#2F2B3D] mt-1">
              $ {Number(refundTransaction?.refundableAmount ?? 0).toFixed(2)}{" "}
              {refundTransaction?.currency ?? "USD"}
            </p>
          </div>
          <div className="mb-6">
            <label className="block text-base font-normal text-gray-600 mb-2">
              Amount you want to refund
            </label>
            <Input
              type="number"
              min={0}
              max={Number(refundTransaction?.refundableAmount ?? 0)}
              value={refundAmount}
              onChange={(e) => setRefundAmount(e.target.value)}
              placeholder="0"
              className="w-full"
              size="large"
            />
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={closeRefundModal}
              className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleRefundSubmit}
              className="bg-primary text-white font-medium px-4 py-2 rounded-lg themeHover duration-500"
            >
              Refund
            </button>
          </div>
        </div>
      </ModalComponent>

      <ConfirmationModal
        isOpen={isRefundConfirmOpen}
        setIsOpen={setIsRefundConfirmOpen}
        type="success"
        message={`Are you sure you want to refund $${Number(refundAmount || 0).toFixed(2)}?`}
        onConfirm={handleRefundConfirm}
        isLoading={isRefundLoading}
        loadingLabel="Processing..."
      />
    </div>
  );
}
